import type { BookingServicePublic } from '~/types/booking'

/** Shared booking popup — lives outside the builder preview transform. */
export function useBookingRequest() {
  const open = useState('booking-request-open', () => false)
  const service = useState<BookingServicePublic | string | null>('booking-request-service', () => null)

  function requestBooking(next: BookingServicePublic | string) {
    service.value = next
    open.value = true
  }

  function closeBooking() {
    open.value = false
    service.value = null
  }

  return { open, service, requestBooking, closeBooking }
}
